import axios from "axios";
import { hideModal } from "../data/modal";

/*****************/
/* INITIAL STATE */
/*****************/
const initialState = {
  loading: false,
  error: "",
  data: [],
  query: { vessel: null, total: null },
};

/*********/
/* TYPES */
/*********/
const FETCH_COMPLETED_TERMINALCALLS = "FETCH_COMPLETED_TERMINALCALLS";
const FETCH_COMPLETED_TERMINALCALLS_SUCCESS = "FETCH_COMPLETED_TERMINALCALLS_SUCCESS";
const FETCH_COMPLETED_TERMINALCALLS_ERROR = "FETCH_COMPLETED_TERMINALCALLS_ERROR";
const FETCH_NEXT_COMPLETED_TERMINALCALLS = "FETCH_NEXT_COMPLETED_TERMINALCALLS";
const FETCH_NEXT_COMPLETED_TERMINALCALLS_SUCCESS = "FETCH_NEXT_COMPLETED_TERMINALCALLS_SUCCESS";

/*******************/
/* ACTION CREATORS */
/*******************/
export const getCompletedTerminalCalls = (page = 1, vessel = null) => async (dispatch) => {
  dispatch({ type: FETCH_COMPLETED_TERMINALCALLS, payload: { page, vessel } });

  try {
    const params = {
      page,
      completed: true,
    };
    if (vessel) {
      params.vessel = vessel["@id"];
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/terminal_calls`,
      {
        params,
        headers: {
          "Content-Type": "application/ld+json; charset=utf-8",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    dispatch({
      type: FETCH_COMPLETED_TERMINALCALLS_SUCCESS,
      payload: {
        items: response.data["hydra:member"],
        page,
        totalPages: response.data["hydra:totalPages"],
        vessel,
      },
    });
  } catch (err) {
    dispatch({
      type: FETCH_COMPLETED_TERMINALCALLS_ERROR,
      payload: err.message || "Failed to fetch",
    });
  }
};

export const getNextCompletedTerminalCalls = (nextUrl) => async (dispatch) => {
  dispatch(loadNextCompletedTerminalCalls());

  const response = await axios({
    method: "get",
    url: `${process.env.REACT_APP_URL}${nextUrl}`,
    headers: {
      "Content-Type": "application/ld+json; charset=utf-8",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  dispatch(setNextCompletedTerminalCalls(response.data["hydra:member"]));

  if (response.data?.["hydra:view"]?.["hydra:next"]) {
    dispatch(getNextCompletedTerminalCalls(response.data["hydra:view"]["hydra:next"]));
  }
};

export const loadCompletedTerminalCalls = () => ({ type: FETCH_COMPLETED_TERMINALCALLS });
export const loadNextCompletedTerminalCalls = () => ({ type: FETCH_NEXT_COMPLETED_TERMINALCALLS });
export const setCompletedTerminalCalls = (items, query) => ({
  type: FETCH_COMPLETED_TERMINALCALLS_SUCCESS,
  payload: { items, query },
});
export const setNextCompletedTerminalCalls = (items) => ({
  type: FETCH_NEXT_COMPLETED_TERMINALCALLS_SUCCESS,
  payload: items,
});
export const setCompletedTerminalCallsError = (msg) => ({
  type: FETCH_COMPLETED_TERMINALCALLS_ERROR,
  payload: msg,
});

/***********/
/* REDUCER */
/***********/
const completedTerminalCallReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_COMPLETED_TERMINALCALLS:
      return { ...state, loading: true, error: "", page: payload.page, vessel: payload.vessel };
    case FETCH_NEXT_COMPLETED_TERMINALCALLS:
      return { ...state, loading: true, error: "" };
    case FETCH_COMPLETED_TERMINALCALLS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.page === 1 ? payload.items : [...state.data, ...payload.items],
        totalPages: payload.totalPages,
        vessel: payload.vessel,
      };
    case FETCH_NEXT_COMPLETED_TERMINALCALLS_SUCCESS:
      return { ...state, loading: false, data: [...state.data, ...payload] };
    case FETCH_COMPLETED_TERMINALCALLS_ERROR:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
};

export default completedTerminalCallReducer;
